import { render, staticRenderFns } from "./CarMaintenanceList.vue?vue&type=template&id=0f3c256f"
import script from "./CarMaintenanceList.vue?vue&type=script&lang=js"
export * from "./CarMaintenanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports